// extracted by mini-css-extract-plugin
module.exports = {"cookieConsent":"CookieConsent_cookieConsent__KmrzJ","inner":"CookieConsent_inner__Hllnu","copy":"CookieConsent_copy__HmTL5","buttons":"CookieConsent_buttons___Uvd0"};